/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2022 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

const VersionMap = Object.freeze({
    latest: "__VERSION__",
    public: "3.74.0_3.2.11-3b53e2f7",
    legacy: "3.74.0_3.2.11-3b53e2f7",
    edit: "2.24.4_2.12.0-7d0a8c15",
});

export default VersionMap;
